export default __webpack_public_path__ + "static/media/cartes-bancaires.54debc51.svg";